(function () {
  'use strict';

  function fmtNumber(n) {
    if (n === null || n === undefined || isNaN(n)) return '–';
    var rounded = Math.round(n * 100) / 100;
    var s = rounded.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
    if (s === '' || s === '-') s = '0';
    return s.replace('.', ',');
  }

  function getValue(productData, key) {
    if (!productData) return null;
    var groups = ['nutrients', 'vitamins', 'minerals'];
    for (var i = 0; i < groups.length; i++) {
      var g = productData[groups[i]];
      if (g && g[key] !== null && g[key] !== undefined) return g[key];
    }
    return null;
  }

  // "CLASSIC – 500g" -> "Classic", "VEGAN ACTIVE – 12 GoBottles à 125 g" -> "Vegan Active"
  function shortVariantLabel(label) {
    if (!label) return '';
    var head = label.split(/[–-]/)[0].trim() || label.trim();
    return head.replace(/\S+/g, function (word) {
      return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
    });
  }

  // Produkt-/Variantendaten gehen per innerHTML-Konkatenation in die Tabelle. Sie sind
  // haendlerkontrolliert (kein externer Angreifer), aber wir escapen sie trotzdem —
  // konsistent zu nutrition-popup.js und robust, falls die Datenquelle je wechselt.
  // NICHT auf das SVG-icon anwenden (bewusstes Markup).
  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function init(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.js-hc-tab'));
    var variantTabsEl = root.querySelector('.js-hc-variant-tabs');
    var catNav = root.querySelector('.js-hc-cat-nav');
    var content = root.querySelector('.js-hc-content');
    var productImage = root.querySelector('.js-hc-product-image');
    if (!content || !tabs.length) return;

    var variantDataCache = {};
    var productMetaCache = {};

    function loadVariantData(variantId) {
      if (variantDataCache[variantId]) return variantDataCache[variantId];
      var el = root.querySelector('.js-hc-variant-data[data-variant-id="' + variantId + '"]');
      var parsed = {};
      if (el) {
        try { parsed = JSON.parse(el.textContent); } catch (e) { parsed = {}; }
      }
      variantDataCache[variantId] = parsed;
      return parsed;
    }

    function loadProductMeta(productId) {
      if (productMetaCache[productId]) return productMetaCache[productId];
      var el = root.querySelector('.js-hc-product-meta[data-product-id="' + productId + '"]');
      var parsed = { variants: [] };
      if (el) {
        try { parsed = JSON.parse(el.textContent); } catch (e) { parsed = { variants: [] }; }
      }
      productMetaCache[productId] = parsed;
      return parsed;
    }

    function renderVariantTabs(productId, activeVariantId) {
      if (!variantTabsEl) return;
      var meta = loadProductMeta(productId);
      var variants = meta.variants || [];

      if (variants.length < 2) {
        variantTabsEl.innerHTML = '';
        variantTabsEl.hidden = true;
        return;
      }

      variantTabsEl.hidden = false;
      variantTabsEl.innerHTML = variants.map(function (v) {
        return '<button type="button" class="hc-variant-tab js-hc-variant-tab' +
          (String(v.id) === String(activeVariantId) ? ' is-active' : '') +
          '" data-variant-id="' + escapeHtml(v.id) + '">' + escapeHtml(shortVariantLabel(v.label)) + '</button>';
      }).join('');

      Array.prototype.slice.call(variantTabsEl.querySelectorAll('.js-hc-variant-tab')).forEach(function (btn) {
        btn.addEventListener('click', function () {
          variantTabsEl.querySelectorAll('.js-hc-variant-tab').forEach(function (b) {
            b.classList.remove('is-active');
          });
          btn.classList.add('is-active');
          render(btn.dataset.variantId);
        });
      });
    }

    function render(variantId) {
      var config = window.BertrandHealthClaims;
      if (!config) return;

      var data = loadVariantData(variantId);
      var i18n = window.bertrandHealthClaimsI18n || {};
      var labels = i18n.labels || {};
      var categoryLabels = i18n.categoryLabels || {};
      var claimTexts = i18n.claimTexts || {};

      var servingG = data.servingSizeG || 100;
      var proteinPer100 = getValue(data, 'protein');
      var fiberPer100 = getValue(data, 'fiber');
      var kcalPer100 = getValue(data, 'energy_kcal');
      if (kcalPer100 === null) {
        var kj = getValue(data, 'energy_kj');
        if (kj !== null) kcalPer100 = kj / 4.184;
      }
      var proteinEnergyPct = null;
      if (proteinPer100 !== null && kcalPer100) {
        proteinEnergyPct = (proteinPer100 * 4 / kcalPer100) * 100;
      }

      if (productImage) {
        if (data.imageUrl) {
          productImage.src = data.imageUrl;
          productImage.alt = data.productTitle || '';
          productImage.style.visibility = '';
        } else {
          productImage.style.visibility = 'hidden';
        }
      }

      var displayName = [data.productTitle, shortVariantLabel(data.variantLabel)].filter(Boolean).join(' – ');

      var navHtml = '';
      var bodyHtml =
        '<p class="hc-portion-note">' +
        (i18n.servingLabel || 'Portion') + ': ' + escapeHtml(displayName) + ' &middot; ' + fmtNumber(servingG) + ' g' +
        '</p>';

      config.CATEGORIES.forEach(function (cat) {
        var rows = config.CLAIMS.filter(function (c) {
          return c.category === cat.id && getValue(data, c.key) !== null;
        });
        if (!rows.length) return;

        var anchorId = 'hc-cat-' + cat.id + '-' + root.dataset.sectionId;
        var icon = (config.ICONS && config.ICONS[cat.id]) || '';
        var categoryLabel = categoryLabels[cat.id] || cat.id;
        navHtml +=
          '<button type="button" class="hc-cat-nav__item js-hc-cat-nav-item" data-target="' + anchorId + '">' +
          '<span class="hc-cat-nav__icon" aria-hidden="true">' + icon + '</span>' +
          '<span class="hc-cat-nav__label">' + categoryLabel + '</span>' +
          '</button>';

        bodyHtml += '<section class="hc-category" id="' + anchorId + '">';
        bodyHtml += '<h3 class="hc-category__heading">' + categoryLabel + '</h3>';
        bodyHtml += '<div class="hc-table" role="table">';
        bodyHtml +=
          '<div class="hc-row hc-row--head" role="row">' +
          '<span role="columnheader">' + (i18n.nutrientCol || 'Nährstoff') + '</span>' +
          '<span role="columnheader">' + (i18n.claimCol || 'Gesundheitsbezogene Aussage') + '</span>' +
          '<span role="columnheader">' + (i18n.preconditionCol || 'Voraussetzung') + '</span>' +
          '<span role="columnheader">' + (i18n.dosageCol || 'Dosierung je Portion') + '</span>' +
          '</div>';

        rows.forEach(function (c) {
          var label = labels[c.key] || c.key;
          var preconditionText;
          var dosageText;
          var met;

          if (c.kind === 'protein_high') {
            preconditionText = i18n.proteinHighPrecondition || 'mind. 20 % des Energiewertes aus Eiweiß';
            dosageText = proteinEnergyPct !== null ? fmtNumber(proteinEnergyPct) + ' ' + (i18n.proteinDosageSuffix || '% des Energiewertes') : '–';
            met = proteinEnergyPct !== null && proteinEnergyPct >= 20;
          } else if (c.kind === 'protein_source') {
            preconditionText = i18n.proteinSourcePrecondition || 'mind. 12 % des Energiewertes aus Eiweiß';
            dosageText = proteinEnergyPct !== null ? fmtNumber(proteinEnergyPct) + ' ' + (i18n.proteinDosageSuffix || '% des Energiewertes') : '–';
            met = proteinEnergyPct !== null && proteinEnergyPct >= 12;
          } else if (c.kind === 'fiber_source') {
            preconditionText = i18n.fiberPrecondition || 'mind. 3 g je 100 g oder mind. 1,5 g je 100 kcal';
            var fiberPer100kcal = fiberPer100 !== null && kcalPer100 ? (fiberPer100 / kcalPer100) * 100 : null;
            var fiberServing = fiberPer100 !== null ? (fiberPer100 * servingG / 100) : null;
            dosageText = fiberServing !== null
              ? fmtNumber(fiberServing) + ' ' + (i18n.fiberDosageTemplate || 'g je Portion') + ' (' + fmtNumber(fiberPer100) + ' g / 100 g)'
              : '–';
            met = (fiberPer100 !== null && fiberPer100 >= 3) || (fiberPer100kcal !== null && fiberPer100kcal >= 1.5);
          } else {
            var nrvEntry = config.NRV[c.key];
            var valuePer100 = getValue(data, c.key);
            if (nrvEntry && valuePer100 !== null) {
              var preconditionVal = nrvEntry.value * 0.15;
              var dosageVal = valuePer100 * servingG / 100;
              preconditionText = fmtNumber(preconditionVal) + ' ' + nrvEntry.unit;
              dosageText = fmtNumber(dosageVal) + ' ' + nrvEntry.unit;
              met = dosageVal >= preconditionVal;
            } else {
              preconditionText = '–';
              dosageText = '–';
              met = false;
            }
          }

          var nutrientColLabel = i18n.nutrientCol || 'Nährstoff';
          var claimColLabel = i18n.claimCol || 'Gesundheitsbezogene Aussage';
          var preconditionColLabel = i18n.preconditionCol || 'Voraussetzung';
          var dosageColLabel = i18n.dosageCol || 'Dosierung je Portion';

          bodyHtml += '<div class="hc-row" role="row">';
          var claimText = claimTexts[c.id] || c.id;
          bodyHtml += '<span class="hc-row__nutrient" role="cell" data-label="' + nutrientColLabel + '">' + label + '</span>';
          bodyHtml += '<span class="hc-row__claim" role="cell" data-label="' + claimColLabel + '">' + claimText + '</span>';
          bodyHtml += '<span class="hc-row__precondition" role="cell" data-label="' + preconditionColLabel + '">' + preconditionText + '</span>';
          bodyHtml +=
            '<span class="hc-row__dosage" role="cell" data-label="' + dosageColLabel + '">' +
            '<span class="hc-row__status' + (met ? ' is-met' : '') + '">' +
            (met ? (i18n.metLabel || '✓') : (i18n.notMetLabel || '—')) +
            '</span> ' + dosageText +
            '</span>';
          bodyHtml += '</div>';
        });

        bodyHtml += '</div></section>';
      });

      if (!navHtml) {
        content.innerHTML = '<p class="hc-empty">' + (i18n.noData || 'Für dieses Produkt liegen keine auswertbaren Nährwertangaben vor.') + '</p>';
        if (catNav) catNav.innerHTML = '';
        return;
      }

      bodyHtml += '<p class="hc-footnote">' + (i18n.footnote ||
        '* NRV = Nährstoffbezugswert je Portion (Verordnung (EU) Nr. 1169/2011). Voraussetzung = gesetzliche Mindestmenge fuer die jeweilige Angabe.') +
        '</p>';

      content.innerHTML = bodyHtml;
      if (catNav) {
        catNav.innerHTML = navHtml;
        bindCatNav();
      }
    }

    function bindCatNav() {
      var items = Array.prototype.slice.call(catNav.querySelectorAll('.js-hc-cat-nav-item'));
      items.forEach(function (item, index) {
        item.addEventListener('click', function () {
          items.forEach(function (i) { i.classList.remove('is-active'); });
          item.classList.add('is-active');
          var target = document.getElementById(item.dataset.target);
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        if (index === 0) item.classList.add('is-active');
      });
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        tabs.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var variantId = btn.dataset.defaultVariantId;
        renderVariantTabs(btn.dataset.productId, variantId);
        render(variantId);
      });
    });

    renderVariantTabs(tabs[0].dataset.productId, tabs[0].dataset.defaultVariantId);
    render(tabs[0].dataset.defaultVariantId);
  }

  function boot() {
    var sections = document.querySelectorAll('.hc-section');
    sections.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
